import styled from "styled-components";
import { mainTabs as testIds } from "../../../../config/testIds";
import {
  DashboardWrapper,
  LoadingInTabWrapper,
  RefreshInTabWrapper,
} from "../../../../style/DashbordWidgetWrappers";
import { useState } from "react";
import SupplierNetworkAppraisersList from "../../../Widgets/SupplierNetwork/SupplierNetworkAppraisersList";
import SupplierNetworkMap from "../../../Widgets/SupplierNetwork/SupplierNetworkMap";
import { AppraisersListItem } from "../../../../redux/apiSpecifications/apiFesf";
import { CommunicationsBySenderTypeAndCategories } from "../../../../redux/apiSpecifications/apiCrud";
import { DateFormat } from "../../../../config/const";
import SupplierNetworkFilter, {
  SupplierNetworkFilterType,
} from "../../../Widgets/SupplierNetwork/SupplierNetworkFilter";
import dayjs from "dayjs";
import Loading from "../../../Loading";

const DashboardNFWrapper = styled(DashboardWrapper)`
  display: flex;
  flex-direction: row;
  gap: 1em;

  .MuiTableCell-root {
    padding: 0;
  }

  .appraisers-list-wrapper {
    flex: 4;
  }

  .col-right {
    display: flex;
    flex-direction: column;
    gap: 1em;
    flex: 3;

    .row-top {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: center;
      gap: 1em;
    }

    .map-wrapper {
      flex: 1;
    }
  }
`;

interface IDashboardNFProps {
  // config
  loadingStatus?: "loading" | "refreshing" | "idle";
  disableMaps?: boolean;
  showAppraiserStatusModal?: boolean;

  // data
  appraisersList?: AppraisersListItem[];
  communicationSummary?: CommunicationsBySenderTypeAndCategories[];
  selectedAppraiser?: AppraisersListItem;

  appraiserToShowOnMap?: number;

  // actions
  onEditAppraiser: (appraiserId: number, nominative: string) => void;
  onEditAppraiserStatus: (appraiserId: number) => void;
  onLoadDataWithDate: (
    searchDate: string | undefined,
    searchDistrictCode: string | undefined
  ) => void;
  onShowAppraiserStatusModal: (show: boolean) => void;
  onShowAppraiserOnMap: (appraiserId: number) => void;
}

const DashBoard_NF_Presentational = (props: IDashboardNFProps) => {
  const {
    loadingStatus,
    disableMaps,
    appraisersList,
    appraiserToShowOnMap,
    onEditAppraiser,
    onEditAppraiserStatus,
    onLoadDataWithDate,
    onShowAppraiserOnMap,
  } = props;

  const [filter, setFilter] = useState<SupplierNetworkFilterType>({
    date: dayjs().format("YYYYMMDD"),
    districtCode: "",
  });

  const handleOnChange = (value: any, field: string) => {
    const newFilter = {
      ...filter,
      [field]: value,
    };

    setFilter(newFilter);

    onLoadDataWithDate(newFilter.date, newFilter.districtCode);
  };

  return (
    <div data-testid={testIds.dashboards.NF}>
      {loadingStatus === "loading" && (
        <LoadingInTabWrapper>
          <Loading />
        </LoadingInTabWrapper>
      )}

      {(loadingStatus === "idle" || loadingStatus === "refreshing") && (
        <>
          <DashboardNFWrapper data-testid={testIds.NF.wrapper}>
            <div className="appraisers-list-wrapper">
              <SupplierNetworkAppraisersList
                items={appraisersList}
                filter={filter}
                onSelectAppraiser={onEditAppraiser}
                onEditAppraiserStatus={onEditAppraiserStatus}
                onShowAppraiserOnMap={onShowAppraiserOnMap}
              />
            </div>

            <div className="col-right">
              <div className="row-top">
                <SupplierNetworkFilter
                  filter={filter}
                  onChange={handleOnChange}
                  onConfirm={() =>
                    onLoadDataWithDate(filter.date, filter.districtCode)
                  }
                />
              </div>

              <div className="map-wrapper">
                {!disableMaps && appraiserToShowOnMap !== undefined && (
                  <SupplierNetworkMap
                    appraiserId={appraiserToShowOnMap}
                    appraiserName={
                      appraisersList?.find((_) => _.id === appraiserToShowOnMap)
                        ?.appraiserName
                    }
                    date={filter.date ?? dayjs().format(DateFormat)}
                  />
                )}
              </div>
            </div>
          </DashboardNFWrapper>

          {loadingStatus === "refreshing" && (
            <RefreshInTabWrapper>
              <Loading />
            </RefreshInTabWrapper>
          )}
        </>
      )}
    </div>
  );
};

export default DashBoard_NF_Presentational;
